<template>
  <svg
    id="A_receber"
    data-name="A receber"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height ? height : width"
    viewBox="0 0 260.57 204.297"
  >
    <g
      id="Retângulo_10"
      data-name="Retângulo 10"
      transform="translate(0 28.297)"
      fill="none"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="15"
    >
      <rect width="182" height="176" rx="35" stroke="none" />
      <rect x="7.5" y="7.5" width="167" height="161" rx="27.5" fill="none" />
    </g>
    <path
      id="Caminho_4"
      data-name="Caminho 4"
      d="M0,.692,176.573-12l-8.125,121.634H0Z"
      transform="translate(83.952 176.573) rotate(-90)"
      fill="#fff"
    />
    <path
      id="Icon_awesome-comment"
      data-name="Icon awesome-comment"
      d="M92.9,2.25C41.589,2.25,0,36.036,0,77.734c0,18,7.766,34.476,20.686,47.432C16.149,143.456.98,159.751.8,159.932a2.885,2.885,0,0,0-.544,3.157A2.842,2.842,0,0,0,2.9,164.831c24.061,0,42.1-11.54,51.024-18.653a110.677,110.677,0,0,0,38.976,7.04c51.315,0,92.9-33.786,92.9-75.484S144.218,2.25,92.9,2.25Z"
      transform="matrix(1, -0.017, 0.017, 1, 71.914, 11.84)"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: { required: false, type: String, default: '100%' },
    height: { required: false, type: String },
    color: { required: false, type: String, default: '#4e73df' }
  }
}
</script>
